export default "__VITE_ASSET__WnDV$iGE__"